import { type ReactElement } from 'react';
import { Controller, type FieldValues } from 'react-hook-form';
import { type PhoneInputControllerProps } from './types';
import { PhoneInput } from '.';

export const PhoneInputController = <T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  className,
  disabled,
  readOnly,
  required,
  defaultValue,
  defaultCountry,
  rules,
  helperText,
  variant,
}: PhoneInputControllerProps<T>): ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    defaultValue={defaultValue}
    render={({ field }) => (
      <PhoneInput
        className={className}
        label={label}
        placeholder={placeholder}
        value={field.value ?? ''}
        onChange={val => field.onChange(val ?? '')}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        defaultCountry={defaultCountry}
        helperText={helperText}
        variant={variant}
      />
    )}
  />
);
